// extracted by mini-css-extract-plugin
export var authorWrapper = "AuthorBio-module--authorWrapper--2i5DL";
export var bioContent = "AuthorBio-module--bioContent--3bWmJ";